import styled, { css } from "styled-components";

const Button = () => css`
  ${({ theme, christmasTheme }) =>
    (theme == "vivaTheme" &&
      `
        position: absolute;
        height: 60px;
        margin: auto;
        width: 100%;
        max-width: 220px;
        bottom: ${christmasTheme ? "40%" : "0px"};


        @media only screen and (max-height: 500px) {
        max-height: 35px;
        max-width: 190px;
        bottom: ${christmasTheme ? "25%" : "0px"};
        };

        @media (max-width: 600px) {
          width: 88%;
          max-width: 220px;
          min-width: 137px;
          bottom: ${christmasTheme ? "14%" : "0px"};
        };

        @media (min-width: 1336px) {
          width: 100%;
          bottom: ${christmasTheme ? "30%" : "0px"};
        };
        `) ||
    (theme != "vivaTheme" &&
      `
      position: relative;
      height: 60px;
      margin: auto;
      width: 40%;
      max-width: 220px;


      @media (max-height: 340px) {
      max-height: 35px;
      max-width: 190px;
      };

      @media (max-height: 500px) and (min-height: 340px) {
      max-height: 40px;
      max-width: 190px;
      };

      @media (max-width: 600px) {
        width: 88%;
        max-width: 220px;
        min-width: 110px;
      };

      @media (min-width: 1336px) {
        width: 13%;
      }
        `)}
`;

export default styled.div([Button]);
